import React from 'react';
import { ProductForm } from '../../../Products/form/ProductForm';
import { useUrlDataContext } from '../../lib/UrlDataContext';
import { useActionContext } from '../../lib/ActionContext';

export const EditProduct = () => {
  const { currentUrlData, queueMatch, isCurrentUrlBlocked } = useUrlDataContext();
  const { setView, productId } = useActionContext();

  return (
    <ProductForm
      saveButtonLabel='Confirm match and save changes'
      categoryStyleguideTarget='url-data-bottom-pane'
      productId={productId}
      pinCount={currentUrlData?.pinCount}
      domain={currentUrlData?.domain}
      onSave={({ product, userCreatedBrand, userCreatedProduct }) => {
        queueMatch({
          hashedUrlStem: currentUrlData.hashedUrlStem,
          productId: product.id,
          metadata: { userCreatedProduct, userCreatedBrand }
        });
      }}
      onBackClick={() => {
        currentUrlData.bestProductMatch?.id ? setView('best-match') : setView('search');
      }}
      showDescriptionFields={false}
      showMetaOptions={false}
      disabled={isCurrentUrlBlocked}
    />
  );
};
